import { Box } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { PrincipalLayouts } from '../../layouts'
import { VehiclesTable } from '../components/vehicles'
import { fetchData } from '../helpers/getData/fetchData'


export const Vehicle = () => {

    const { t } = useTranslation('global')
    const [vehiclesList, setVehiclesList] = useState('loading')
    const [reloadData, setReloadData] = useState(false)

    useEffect(() => {
        fetchData(setVehiclesList, '/vehicle', t);
    }, [reloadData, t])

    return (
        <PrincipalLayouts>
            <Box minHeight='calc(100vh - 125px)'>
                {
                    vehiclesList !== 'loading' &&
                    <VehiclesTable rows={vehiclesList} setReloadData={setReloadData} />
                }
            </Box>
        </PrincipalLayouts>
    )
}
